import React from 'react';
import { AlertCircle, Camera, Shapes, ShieldCheck } from 'lucide-react';

function Stat({ icon: Icon, label, value, tone = 'neutral' }) {
  return (
    <article className={`stat-card stat-card--${tone}`}>
      <div className="stat-card__icon">
        <Icon size={16} />
      </div>
      <div>
        <p>{label}</p>
        <h4>{value}</h4>
      </div>
    </article>
  );
}

// With small counts, two (or more) classes often tie for the lead - showing
// just one as "Top" implies a winner that isn't really there. List every
// class tied for first instead of arbitrarily picking one.
function topClassLabel(byClass) {
  if (!byClass.length) return 'None';
  const topCount = byClass[0].count;
  const tied = byClass.filter((row) => row.count === topCount);
  return tied.map((row) => row.class_name).join(' / ');
}

export default function StatsSummary({ summary }) {
  const byCamera = summary?.by_camera || [];
  const byClass = summary?.by_class || [];
  const total = summary?.total_alerts || 0;

  return (
    <section className="summary-grid">
      <Stat icon={AlertCircle} label="Total Alerts" value={total} tone="danger" />
      <Stat icon={Camera} label="Active Cameras" value={byCamera.length || 2} tone="neutral" />
      <Stat
        icon={Shapes}
        label="Top Class"
        value={topClassLabel(byClass)}
        tone="accent"
      />
      <Stat icon={ShieldCheck} label="System Status" value="Online" tone="success" />
    </section>
  );
}
